/**
 * Actions
 */
export const Actions = {
    ADD_NOTIFICATION: 'ADD_NOTIFICATION',
    REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
    REMOVE_ALL_NOTIFICATIONS: 'REMOVE_ALL_NOTIFICATIONS',

    OPEN_AFFECTATION_DIALOG: 'OPEN_AFFECTATION_DIALOG',
    CLOSE_AFFECTATION_DIALOG: 'CLOSE_AFFECTATION_DIALOG',

    OPEN_ADD_RECLAMATION_DIALOG: 'OPEN_ADD_RECLAMATION_DIALOG',
    CLOSE_ADD_RECLAMATION_DIALOG: 'CLOSE_ADD_RECLAMATION_DIALOG',

    OPEN_OBSERVATEURS_DIALOG: 'OPEN_OBSERVATEURS_DIALOG',
    CLOSE_OBSERVATEURS_DIALOG: 'CLOSE_OBSERVATEURS_DIALOG',

    OPEN_ADD_MEMO_DIALOG: 'OPEN_ADD_MEMO_DIALOG',
    CLOSE_ADD_MEMO_DIALOG: 'CLOSE_ADD_MEMO_DIALOG',

    OPEN_ADD_QUESTION_DIALOG: 'OPEN_ADD_QUESTION_DIALOG',
    CLOSE_ADD_QUESTION_DIALOG: 'CLOSE_ADD_QUESTION_DIALOG',

    OPEN_CLOTURE_DIALOG: 'OPEN_CLOTURE_DIALOG',
    CLOSE_CLOTURE_DIALOG: 'CLOSE_CLOTURE_DIALOG',

    OPEN_ANNULER_CLOTURE_DIALOG: 'OPEN_ANNULER_CLOTURE_DIALOG',
    CLOSE_ANNULER_CLOTURE_DIALOG: 'CLOSE_ANNULER_CLOTURE_DIALOG',

    OPEN_ADD_ACTION_DIALOG: 'OPEN_ADD_ACTION_DIALOG',
    CLOSE_ADD_ACTION_DIALOG: 'CLOSE_ADD_ACTION_DIALOG',

    OPEN_SET_DATE_VERIFICATION_DIALOG: 'OPEN_SET_DATE_VERIFICATION_DIALOG',
    CLOSE_SET_DATE_VERIFICATION_DIALOG: 'CLOSE_SET_DATE_VERIFICATION_DIALOG',

    UPDATE_DROPZONE: 'UPDATE_DROPZONE',

    ENTER_ADMINISTRATION_MODE: 'ENTER_ADMINISTRATION_MODE',
    LEAVE_ADMINISTRATION_MODE: 'LEAVE_ADMINISTRATION_MODE',


    OPEN_IMPORT_SOUFFRANCE_DIALOG: 'OPEN_IMPORT_SOUFFRANCE_DIALOG',
    CLOSE_IMPORT_SOUFFRANCE_DIALOG: 'CLOSE_IMPORT_SOUFFRANCE_DIALOG'
     
};

export const NotificationImportance = {
    information: 'information',
    success: 'success',
    warning: 'warning',
    error: 'error'
};

//
// ActionCreator pour les notifications
//
export const addNotification = (message, importance, closable = false, url = null) => ({ type: Actions.ADD_NOTIFICATION, message, importance, closable, url });
export const removeNotification = () => ({ type: Actions.REMOVE_NOTIFICATION });
export const removeAllNotifications = () => ({ type: Actions.REMOVE_ALL_NOTIFICATIONS });

//
// ActionCreator pour l'affectation
//
export const openAffectationDialog = (reclamationId) => ({ type: Actions.OPEN_AFFECTATION_DIALOG, reclamationId });
export const closeAffectationDialog = () => ({ type: Actions.CLOSE_AFFECTATION_DIALOG });

//
// ActionCreator pour l'ouverture et la fermeture de la dialog de création de réclamation.
//
export const openAddReclamationDialog = (reclamationLiee, reclamationParentId, infosLogistique) => ({ type: Actions.OPEN_ADD_RECLAMATION_DIALOG, reclamationLiee, reclamationParentId, infosLogistique });
export const closeAddReclamationDialog = () => ({ type: Actions.CLOSE_ADD_RECLAMATION_DIALOG });

//
// ActionCreator pour l'ouverture et la fermeture de la dialog des observateurs d'une réclamation
//
export const openObservateursDialog = () => ({ type: Actions.OPEN_OBSERVATEURS_DIALOG });
export const closeObservateursDialog = () => ({ type: Actions.CLOSE_OBSERVATEURS_DIALOG });

//
// ActionCreator pour l'ajout de mémo
//
export const openAddMemoDialog = (reclamationId) => ({ type: Actions.OPEN_ADD_MEMO_DIALOG, reclamationId });
export const closeAddMemoDialog = () => ({ type: Actions.CLOSE_ADD_MEMO_DIALOG });

//
// ActionCreator pour l'ajout de question
//
export const openAddQuestionDialog = (reclamationId) => ({ type: Actions.OPEN_ADD_QUESTION_DIALOG, reclamationId });
export const closeAddQuestionDialog = () => ({ type: Actions.CLOSE_ADD_QUESTION_DIALOG });

//
// ActionCreator pour la cloture de la réclamation
//
export const openClotureDialog = (reclamationId) => ({ type: Actions.OPEN_CLOTURE_DIALOG, reclamationId });
export const closeClotureDialog = () => ({ type: Actions.CLOSE_CLOTURE_DIALOG });

//
// ActionCreator pour l'annulation de la cloture de la réclamation.
//
export const openAnnulerClotureDialog = (reclamationId) => ({ type: Actions.OPEN_ANNULER_CLOTURE_DIALOG, reclamationId });
export const closeAnnulerClotureDialog = () => ({ type: Actions.CLOSE_ANNULER_CLOTURE_DIALOG });

//
// ActionCreator pour l'ajout d'action
//
export const openAddActionDialog = (reclamationId, action) => ({ type: Actions.OPEN_ADD_ACTION_DIALOG, reclamationId, action });
export const closeAddActionDialog = () => ({ type: Actions.CLOSE_ADD_ACTION_DIALOG });


//
// ActionCreator pour la modification de la date de vérification
//
export const openSetDateVerificationDialog = (reclamationId, date) => ({ type: Actions.OPEN_SET_DATE_VERIFICATION_DIALOG, reclamationId, date });
export const closeSetDateVerificationDialog = () => ({ type: Actions.CLOSE_SET_DATE_VERIFICATION_DIALOG });


//
// ActionCreator pour la maj de la dropzone
//
export const updateDropZone = (dropZone) => ({ type: Actions.UPDATE_DROPZONE, dropZone });


//
// ActionCreator pour l'entrée en mode administration
//
export const enterAdministrationMode = () => ({ type: Actions.ENTER_ADMINISTRATION_MODE });
export const leaveAdministrationMode = () => ({ type: Actions.LEAVE_ADMINISTRATION_MODE });


//
// ActionCreator pour l'import de souffrance
//
export const openImportSouffranceDialog = () => ({ type: Actions.OPEN_IMPORT_SOUFFRANCE_DIALOG });
export const closeImportSouffranceDialog = () => ({ type: Actions.CLOSE_IMPORT_SOUFFRANCE_DIALOG });

